export enum Social {
  FACEBOOK = 'Facebook',
  LINKEDIN = 'LinkedIn',
  TWITTER = 'Twitter',
  EMAIL = 'Email',
}
